import {SecondaryButton} from 'components';
import React from 'react';
import Chart from 'react-apexcharts';

function DocumentAnalysisChart() {
  const chartData = {
    series: [
      {
        name: 'INTERNATIONAL PASSPORT',
        data: [95, 175, 180, 185, 180, 180, 180, 180, 180, 180, 180],
      },
      {
        name: "VOTER'S CARD",
        data: [75, 110, 115, 115, 115, 115, 115, 115, 115, 115, 110],
      },
      {
        name: 'NATIONAL ID',
        data: [35, 50, 55, 55, 50, 55, 55, 50, 50, 55, 50],
      },
      {
        name: 'RESIDENTIAL PERMIT',
        data: [50, 45, 50, 55, 55, 55, 55, 55, 55, 55, 55],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {show: false},
        background: '#FFFFFF',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '75%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {enabled: false},
      stroke: {show: true, width: 4, colors: ['transparent']},
      xaxis: {
        categories: [
          'JAN',
          'FEB',
          'MAR',
          'APR',
          'MAY',
          'JUN',
          'JUL',
          'AUG',
          'SEP',
          'OCT',
          'NOV',
        ],
        labels: {style: {colors: '#6E6E6E', fontSize: '12px'}},
        axisBorder: {show: false},
        axisTicks: {show: false},
      },
      yaxis: {
        labels: {style: {colors: '#6E6E6E', fontSize: '12px'}},
        axisBorder: {show: false},
        axisTicks: {show: false},
      },
      fill: {opacity: 1},
      grid: {
        show: true,
        borderColor: '#F9F9F9',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {lines: {show: false}},
        yaxis: {lines: {show: true}},
        padding: {left: 10, right: 10},
      },
      legend: {
        show: false,
      },
      colors: ['#87D4DB', '#2A5392', '#3F7CDB', '#2B5125'],
    },
  };

  const legendData = chartData.series.map((item, index) => ({
    label: item.name,
    color: chartData.options.colors[index],
  }));

  return (
    <div className="bg-white mt-5 h-full shadow-cards rounded-xl border-[0.5px] border-[#EFEFEF]">
      <div className="bg-[#F9F9F9] py-3 px-6 rounded-t-xl">
        <p className="font-medium text-sm xl:text-base text-deepBlue">
          Document analysis
        </p>
      </div>

      <div className="flex flex-wrap gap-4 items-center justify-between p-6">
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          {legendData.map((item, index) => (
            <div key={index} className="flex items-center space-x-2">
              <span
                className="w-3 h-3 rounded-full"
                style={{backgroundColor: item.color}}
              ></span>
              <span className="text-xs text-gray-600 font-medium">
                {item.label}
              </span>
            </div>
          ))}
        </div>
        <SecondaryButton buttonText="Filter" />
        Mesaad
      </div>

      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={350}
      />
    </div>
  );
}

export default DocumentAnalysisChart;
